<ng-container *ngIf="conversation$ | async as conversation">
  <div class="item traversable-list-item"
       [ngClass]="themeCssClassName$ | async"
       [class.opened]="isOpened"
       [class.focus]="isFocused"
       [attr.tabindex]="0"
       (click)="selectConversation(conversation, true)"
       (keydown.enter)="selectConversation(conversation, true)"
       (keydown.shift.enter)="selectConversation(conversation, false)">
    <div class="item-inner">
      <div class="visitor-avatar">
        <svg-avatar [id]="avatarThemeId$ | async"></svg-avatar>
      </div>

      <div class="visitor-name gc-text-bold">
        <app-genesys-contact-display-name [contact]="contact$ | async"></app-genesys-contact-display-name>
      </div>

      <span class="conversation-type-indicator">
        <svg-icon *ngIf="(conversationType$ | async) !== undefined" icon="genesys-{{conversationType$ | async}}"></svg-icon>
      </span>

      <workitem-activity-indicator [unansweredMessageCount]="unansweredMessageCount$ | async"
                                   [showElapsedTimer]="true"
                                   [showSecondsRemaining]="isSecondsRemainingVisible$ | async"
                                   [secondsRemainingDisplay]="conversationAlertingTimeout$ | async | appFormatSeconds"
                                   [showWrapUpIndicator]="(isConversationOpen$ | async) === false"
                                   [forceDisableRedDots]="(isConversationOpen$ | async) === false">
      </workitem-activity-indicator>

      <div class="messages">
        <div *ngFor="let message of lastMessages$ | async" class="message" [class.received]="isCustomerMessage(message)"
             [innerHTML]="((shouldFormatMessage$ | async) ? (message.textBody | appMdToHtml : { replaceLinksWithPlainText: true }) : message.textBody)">
        </div>
      </div>

      <div class="shortcut">
        <svg-icon icon="enter-key"></svg-icon>
      </div>
    </div>
  </div>

  <app-work-item-interaction *ngIf="conversation?.isAcceptable" (accept)="selectConversation(conversation, false)"></app-work-item-interaction>
</ng-container>
